import Link from 'next/link';

import { NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID } from '@/constants/addresses';
import { CHAIN_IDS } from '@/constants/chain';

import { tradeRoute } from '@/utils/url';

import { useMatchaWallets } from '../../../hooks/useMatchaWallets';
import { buttons } from '../../../styles/buttons';
import { fontStyles } from '../../../styles/typography';
import { getConnectedChain } from '../../../utils/wallet';
import { StyledParagraph } from '../utils';

export function LimitOrdersHero() {
  const { ethereumWallet } = useMatchaWallets();
  const chainId = getConnectedChain(ethereumWallet)?.id ?? CHAIN_IDS.MAINNET;

  return (
    <header className="pb-0 mt-[152px] mb-[122px] grid relative bg-[url(/images/limit-orders/price-history-mobile.svg)] bg-no-repeat bg-[center_45%] bg-[length:100%_auto] tablet:mb-[9.6rem] tablet:bg-[url(/images/limit-orders/price-history-tablet.svg)] tablet:bg-[unset] desktop:bg-[url(/images/limit-orders/price-history-desktop.svg)]">
      <div className="pt-[9.6rem] pb-[6.8rem] tablet:pb-[9.6rem] mx-auto tablet:mx-[2.6rem] z-[1] bg-[radial-gradient(50.13%_42.41%_at_50%_52.44%,_#FFF_0%,_#FFF_29.69%,_rgba(255,255,255,0.64)_62.5%,_rgba(255,255,255,0.00)_100%)] pl-[2.5rem] pr-[2.5rem] tablet:pl-[8.4rem] tablet:pr-[8.4rem] desktop:max-w-[992px] desktop:w-full desktop:ml-auto desktop:mr-auto">
        <h4
          className={fontStyles({
            variant: 'H2',
            class: [
              'text-center bg-gradient-to-r from-[rgba(2,168,99,1)] via-[rgba(2,168,99,0.49)] to-[rgba(118,182,36,1)] bg-clip-text text-transparent font-bold text-[1.25rem] leading-[3.5rem]',
            ],
          })}
        >
          Master volatile markets
        </h4>
        <h1
          className={fontStyles({
            variant: 'H1',
            class: [
              'text-center',
              'grid',
              'mb-6',
              'text-[46px]',
              'leading-[48px]',
              'tablet:text-[64px]',
              'tablet:leading-[78px]',
            ],
          })}
        >
          Limit orders
        </h1>
        <StyledParagraph
          className={fontStyles({
            variant: 'BODY_LG',
            class: [
              'text-token-gray-800',
              'text-center',
              'grid',
              'mb-12',
              'mx-auto',
              'max-w-[460px]',
              'tablet:max-w-[31rem]',
            ],
          })}
        >
          Get the price you want. No surprises.
        </StyledParagraph>
        <div className="grid justify-center items-center">
          <Link
            href={tradeRoute(
              { address: NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID[chainId], chainId },
              'limit',
            )}
          >
            <div
              className={buttons({
                size: 'medium',
                class: [
                  'bg-token-gray-1600',
                  'text-token-gray-100',
                  'rounded-[26px]',
                  'shadow-[0px_-1px_1px_0px_rgba(0,0,0,0.04)_inset,0px_1px_3px_0px_rgba(0,0,0,0.20)]',
                  'px-4',
                ],
              })}
            >
              Start trading
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
}
